import { createContext } from '@berlin-front/common/composables/context';
import { broadcast } from '@/broadcast';

const useFailCart = () => {
  const cancel = () => {
    broadcast.send({ type: 'MODAL_CONTROL_INVALID' });
  };

  return {
    cancel,
  };
};

export const FailCartContext = createContext({ useFailCart });
